<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.ftp.host')}}/Port:</label>
            <div class="col-6">
                <input type="text" v-model="value.Host" class="form-control" required maxlength="300" />
            </div>
            <div class="col-3">
                <input type="number" v-model="value.Port"  class="form-control" required min="1" max="65536" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.ftp.username')}}</label>
            <div class="col">
                <input v-model="value.Credential.Username" type="text" class="form-control" required />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.ftp.passcode')}}</label>
            <div class="col">
                <!-- <input v-model="value.Credential.Password" type="password" class="form-control" required    onpaste="return false;" oncopy="return false;" autofill="return false;"  /> -->
                <password v-model="value.Credential.Password" class="form-control" required @change="$forceUpdate()" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.ftp.uzakDizin')}}</label>
            <div class="col">
                <div class="input-group mb-3">
                    <input v-model="value.Path" type="text" class="form-control" required />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                            {{translate('lookup')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.EnableSSL" />
                    {{translate('targetSystem.ftp.sslEnabled')}}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import password from '@/components/Password.vue'

export default {
    components: {
        password
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {

    }
}

</script>
